import { ActionsTypes } from "../actions/playerActions"

type InitialStateType = typeof initialState

const initialState = {
    artist: null as String | null,
    title: null as String | null,
    schemaBoolean: null as { [key: string]: String } | null,
    songMap: null as Map<string, boolean> | null,
    currentSource: null as string | null,
    currentTime: 0 as number,
    isFetching: false as boolean,
    art: null as String | null
}

export const playerReducer = (state = initialState, action: ActionsTypes): InitialStateType => {
    switch (action.type) {
        case 'GET_SONG_MAP': {
            let songStructure: string[] = action.song.schemaString.split(' ')
            const songMap = new Map<string, boolean>()
            songStructure.forEach(el => {
                songMap.set(el, false)
            })
            return {
                ...state,
                songMap: songMap,
                artist: action.song.artist,
                title: action.song.title,
                art: action.song.art,
                schemaBoolean: action.song.schemaBoolean,
                currentSource: action.song.schemaBoolean[(Array.from(songMap.values()).join(' '))] as string

            }
        }
        case 'UPDATE_SONG_MAP':
            let updatedSongMap = new Map<string, boolean>()
            const songMap = state.songMap
            if (songMap) {
                for (let [key, value] of songMap) {
                    updatedSongMap.set(key, value)
                }
            }
            updatedSongMap.set(action.slice, !updatedSongMap.get(action.slice))

            return {
                ...state,
                songMap: updatedSongMap,
                currentSource: state.schemaBoolean ? state.schemaBoolean[(Array.from(updatedSongMap.values()).join(' '))] as string : '',
                currentTime: action.currentTime
            }
        case 'IS_FETCHING':
            return {
                ...state,
                isFetching: action.isFetching
            }
        case 'PLAYER_RESET':
            return initialState
        default: return state
    }
}